import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import * as React from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import { Menu, Item } from './menu';
import usePopper from '../_utils/usePopper';
import { isFragment } from '../_utils/reactNode';
var findItem = function findItem(element) {
  var isItem = /dropdown-menu-item/.test(element.className);
  if (isItem) {
    return element;
  } else {
    return element.parentNode ? findItem(element.parentNode) : null;
  }
};
var Dropdown = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _a, _b, _c, _d;
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls,
    pkgPrefixCls = _React$useContext.prefixCls,
    userDefaultProps = _React$useContext.compDefaultProps;
  // 属性需要合并一遍用户定义的默认属性
  var allProps = getCompProps('Dropdown', userDefaultProps, props);
  var menu = allProps.menu,
    disabled = allProps.disabled,
    children = allProps.children,
    selectable = allProps.selectable,
    onItemClick = allProps.onItemClick,
    defaultVisible = allProps.defaultVisible,
    onVisibleChange = allProps.onVisibleChange,
    trigger = allProps.trigger,
    customPrefixcls = allProps.prefixCls,
    menuAnimation = allProps.menuAnimation,
    popperStyle = allProps.popperStyle;
  var prefixCls = getPrefixCls(pkgPrefixCls, 'dropdown', customPrefixcls);
  var innerAnimation = typeof menuAnimation === 'boolean' ? menuAnimation : trigger !== 'contextMenu';
  var _React$useState = React.useState(!!props.visible || defaultVisible),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    visible = _React$useState2[0],
    setVisible = _React$useState2[1];
  React.useEffect(function () {
    setVisible(!!props.visible);
  }, [props.visible]);
  var handleVisibleChange = function handleVisibleChange(visible) {
    props.visible === undefined && setVisible(visible);
    onVisibleChange && onVisibleChange(visible);
  };
  var child = children && ((_a = children === null || children === void 0 ? void 0 : children.type) === null || _a === void 0 ? void 0 : _a.displayName) === 'Input' ? /*#__PURE__*/React.createElement("span", {
    className: classNames("".concat(prefixCls, "-trigger"), "".concat(prefixCls, "-trigger-container")),
    ref: ref
  }, trigger === 'focus' ? /*#__PURE__*/React.cloneElement(React.Children.only(children), {
    onFocus: function onFocus(e) {
      children.props.onFocus && children.props.onFocus(e);
      handleVisibleChange(true);
    },
    onBlur: function onBlur(e) {
      children.props.onBlur && children.props.onBlur(e);
      handleVisibleChange(false);
    }
  }) : children) : /*#__PURE__*/React.cloneElement( /*#__PURE__*/React.isValidElement(children) && !isFragment(children) ? children : /*#__PURE__*/React.createElement("span", null, children), {
    ref: /*#__PURE__*/React.isValidElement(children) && !isFragment(children) && children.ref ? children.ref : ref,
    className: classNames("".concat(prefixCls, "-trigger"), /*#__PURE__*/React.isValidElement(children) && !isFragment(children) && children.props && children.props.className, {
      disabled: disabled
    })
  });
  var isMenu = menu.type === Menu;
  var _React$useState3 = React.useState(props.selectedKey || ((_b = menu.props) === null || _b === void 0 ? void 0 : _b.defaultKey) || props.defaultKey || ''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    selectedKey = _React$useState4[0],
    setSelectedKey = _React$useState4[1];
  React.useEffect(function () {
    if (typeof props.selectedKey !== 'undefined') {
      setSelectedKey(props.selectedKey);
    }
  }, [props.selectedKey]);
  var menuSelectable = ((_c = menu.props) === null || _c === void 0 ? void 0 : _c.selectable) === undefined ? selectable : (_d = menu.props) === null || _d === void 0 ? void 0 : _d.selectable;
  var handleItemClick = function handleItemClick(e) {
    var _a;
    var item = findItem(e.target);
    var key = (_a = item === null || item === void 0 ? void 0 : item.dataset) === null || _a === void 0 ? void 0 : _a.key;
    if ((item === null || item === void 0 ? void 0 : item.className.indexOf('disabled')) === -1 && key) {
      if (isMenu && menu.props.onClick) {
        menu.props.onClick(key);
      } else if (onItemClick) {
        onItemClick(key);
      }
      menuSelectable && setSelectedKey(key);
      props.visible === undefined && setVisible(false);
    }
  };
  var cloneObj = /*#__PURE__*/React.cloneElement(menu, {
    selectedKey: selectedKey,
    onClick: handleItemClick,
    selectable: menuSelectable
  });
  var menuElement = isMenu ? cloneObj : /*#__PURE__*/React.createElement("ul", {
    className: "".concat(prefixCls, "-menu"),
    onClick: handleItemClick,
    role: "menu"
  }, _mapInstanceProperty(menu).call(menu, function (_ref) {
    var itemKey = _ref.key,
      label = _ref.label,
      href = _ref.href,
      danger = _ref.danger,
      divided = _ref.divided,
      disabled = _ref.disabled;
    var alinkProps = {
      href: href,
      target: '_blank',
      rel: 'noopener noreferrer'
    };
    var key = itemKey || label;
    var selected = selectable && String(selectedKey) === String(key);
    return /*#__PURE__*/React.createElement("li", {
      title: label,
      key: key,
      "data-key": key,
      className: classNames("".concat(prefixCls, "-menu-item"), {
        danger: danger,
        divided: divided,
        disabled: disabled,
        selected: selected
      }),
      role: "menuitem"
    }, href === undefined || disabled ? /*#__PURE__*/React.createElement("span", null, label) : /*#__PURE__*/React.createElement("a", _extends({}, alinkProps), /*#__PURE__*/React.createElement("span", null, label)));
  }));
  var popperProps = _extends(_extends({}, allProps), {
    visible: visible,
    prefixCls: prefixCls,
    popperStyle: innerAnimation ? popperStyle : _extends({
      animation: 'none'
    }, popperStyle),
    onVisibleChange: handleVisibleChange
  });
  return usePopper(child, menuElement, popperProps);
});
Dropdown.displayName = 'Dropdown';
var OuterDropdown = Dropdown;
OuterDropdown.Menu = Menu;
OuterDropdown.Item = Item;
export default OuterDropdown;